export default {"src":"/_next/static/media/dishes_and_silverware.1c809cfe.svg","height":100,"width":100};